import React from "react";

export default function Resume() {
  const pdfUrl = "/Gabriel_Seng_Resume.pdf";
  const imgUrl = "/Gabriel_Seng_Resume.png";

  return (
    <section id="resume" className="py-20 px-6 bg-white">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-900 mb-10 text-center">
          Resume
        </h2>

        {/* Resume image */}
        <div className="w-full rounded-lg overflow-hidden border border-gray-200 mb-6">
          <img
            src={imgUrl}
            alt="Gabriel Seng Resume"
            className="w-full h-auto"
          />
        </div>

        {/* Download button */}
        <div className="text-center">
          <a
            href={pdfUrl}
            download="Gabriel_Seng_Resume.pdf"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
}
